import React, {useCallback, useMemo} from 'react';
import {Box, Tooltip} from '@mui/material';
import {useNavigate} from 'react-router';
import {useShortcut} from 'services/shortcuts';
import {ToolBar} from '../toolbar';

type NextButtonProps<T extends {link: string; tooltip: string}> = {
  items: T[];
  setter: (items: T[]) => void;
};

export const NextButton = <T extends {link: string; tooltip: string}>({
  items,
  setter,
}: NextButtonProps<T>) => {
  const navigate = useNavigate();
  const goToNextTodo = useCallback(() => {
    if (items.length === 0) {
      return;
    }

    const [next, ...rest] = items;
    setter(rest);

    return navigate(next.link);
  }, [setter, items, navigate]);

  const NextTodoButton = useMemo(() => {
    if (items.length > 0) {
      return (
        <Tooltip
          title={items[0].tooltip}
          arrow
          slotProps={{
            popper: {
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [0, -14],
                  },
                },
              ],
            },
          }}>
          <Box>
            <ToolBar.IconTool
              icon="DoubleChevronRight"
              onClick={goToNextTodo}
            />
          </Box>
        </Tooltip>
      );
    }

    return null;
  }, [items, goToNextTodo]);

  useShortcut('goToNext', goToNextTodo);

  return NextTodoButton;
};
